import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import isBase64 from 'is-base64';

enum IconType {
  None,
  Css,
  Svg,
  Image,
}

export type IconAs = 'auto' | 'svg' | 'image' | 'css';

const prefixBase64 = 'data:image/png;base64,';

@Component({
  selector: 'app-iconic',
  templateUrl: 'iconic.component.html',
  styleUrls: ['iconic.component.scss'],
})
export class IconicComponent implements OnChanges {
  @Input()
  icon: string;

  @Input()
  useAs: IconAs = 'auto';

  iconValue: string;

  iconTypes = IconType;
  iconType: IconType;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.icon || changes.useAs) {
      if (!this.icon) {
        this.iconValue = null;
        this.iconType = IconType.None;
        return;
      }

      const icon = String(this.icon);

      switch (this.useAs) {
        case 'svg':
          this.handleIconAsSvg(icon);
          break;
        case 'css':
          this.handleIconAsCss(icon);
          break;
        case 'image':
          this.handleIconAsImage(icon);
          break;
        case 'auto':
        default:
          this.handleIconAsAuto(icon);
          break;
      }
    }
  }

  private handleIconAsAuto(icon: string) {
    if (this.isSource(icon)) {
      if (icon.endsWith('.svg')) {
        this.handleIconAsSvg(icon);
      } else {
        this.handleIconAsImageUrl(icon);
      }
    } else {
      const base64Bool = isBase64(icon, { allowMime: true });
      if (base64Bool) {
        this.handleIconAsBase64(icon);
      } else {
        this.handleIconAsCss(icon);
      }
    }
  }

  private handleIconAsSvg(icon: string) {
    this.iconValue = icon;
    this.iconType = IconType.Svg;
  }

  private handleIconAsCss(icon: string) {
    this.iconValue = icon;
    this.iconType = IconType.Css;
  }

  private handleIconAsImage(icon: string) {
    if (this.isSource(icon)) {
      this.iconType = IconType.Image;
      this.iconValue = icon;
    } else {
      this.handleIconAsBase64(icon);
    }
  }

  private handleIconAsImageUrl(icon: string) {
    this.iconType = IconType.Image;
    this.iconValue = icon;
  }

  private handleIconAsBase64(icon: string) {
    this.iconType = IconType.Image;

    const hasMime = isBase64(icon, { mimeRequired: true });
    if (!hasMime) {
      icon = prefixBase64 + icon;
    }

    this.iconValue = icon;
  }

  private isSource(icon: string) {
    return (
      icon.startsWith('assets/') ||
      icon.startsWith('blob:') ||
      icon.startsWith('http://') ||
      icon.startsWith('https://')
    );
  }
}
